import { render, staticRenderFns } from "./space.vue?vue&type=template&id=6507dc03"
import script from "./space.vue?vue&type=script&lang=ts"
export * from "./space.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports